<template>
  <div class="home">
    <ChatRDG :drawer="drawer" @close-drawer="$emit('close-drawer')" />
  </div>
</template>

<script>
// @ is an alias to /src
import ChatRDG from "@/components/ChatRDG.vue";

export default {
  name: "ChatBotView",
  props: ['drawer'],
  emits: ['close-drawer'],
  components: {
    ChatRDG,
  },
};
</script>
